import React from 'react';
import { Card, CardBody, CardTitle, CardText } from 'reactstrap';
import logo from "../assets/University Officials/image9.jpg";

const FinanceOfficer = () => {
    return (
        <div className="container mt-5 mb-5">
            <Card className="shadow border-0 rounded-4">
                <div className="row g-0">
                    <div className="col-md-4 d-flex align-items-center justify-content-center p-4">
                        <img
                            src={logo}
                            alt="वित्ताधिकारी"
                            className="img-fluid rounded-3 shadow-sm"
                            style={{ maxHeight: '300px', objectFit: 'cover' }}
                        />
                    </div>
                    <div className="col-md-8">
                        <CardBody className="p-4">
                            <CardTitle tag="h4" className="text-center text-primary fw-bold">
                                वित्ताधिकारी
                            </CardTitle>
                            <CardText className="fs-5">
                                <strong>श्री कृष्ण कुमार</strong><br />
                                वित्ताधिकारी
                            </CardText>
                            <hr />
                            <CardText className="mt-3">
                                <strong>संपर्क:</strong> 079883-10076<br />
                                <strong>ई-मेल:</strong> <a href="mailto:financeofficer@mvsu.ac.in">financeofficer@mvsu.ac.in</a><br />
                                <strong>अस्थाई परिसर:</strong><br />
                                डॉ. भीम राव अम्बेडकर राजकीय महाविद्यालय,<br />
                                जगदीशपुरा, कैथल (हरियाणा) – 136027
                            </CardText>
                        </CardBody>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default FinanceOfficer;
